import axios from 'axios'

const apiUrl = 'https://sitebypro-server.ru/druzbamebel'

export default {
  state: {
    payment_method: null,
    checkoutLoading: false,
    paymentConfig: {
      configured: null,
      yandex_pay_configured: null,
      yandex_split_configured: null,
      mode: 'test',
      yandex_pay: { configured: false, mode: 'test', merchant_id: '', callback_url: '' },
      pickup_address: 'Астрахань, Смоляной переулок, 2Б, лит. 1, 414056'
    }
  },
  getters: {
    payment_method(state) {
      return state.payment_method
    },
    checkoutLoading(state) {
      return state.checkoutLoading
    },
    paymentConfig(state) {
      return state.paymentConfig
    }
  },
  mutations: {
    CHOOSE_PAYMENT_METHOD(state, data) {
      state.payment_method = data || null
    },
    SET_CHECKOUT_LOADING(state, value) {
      state.checkoutLoading = Boolean(value)
    },
    SET_PAYMENT_CONFIG(state, value) {
      state.paymentConfig = value && typeof value === 'object'
        ? { ...state.paymentConfig, ...value }
        : state.paymentConfig
    }
  },
  actions: {
    async GET_PAYMENT_CONFIG({ commit }) {
      try {
        const response = await axios.get(`${apiUrl}/payments/config`, { timeout: 8000 })
        const config = response && response.data && response.data.data
        if (config) commit('SET_PAYMENT_CONFIG', config)
        return config || {}
      } catch (error) {
        console.warn('Не удалось получить настройки оплаты', error)
        return {}
      }
    },
    async GET_PAYMENT_STATUS(context, data) {
      const response = await axios.post(`${apiUrl}/payments/status`, data, { timeout: 12000 })
      if (String(response && response.data && response.data.status) !== '200') {
        const message = response && response.data && response.data.data && response.data.data.text
          ? response.data.data.text
          : 'Не удалось получить статус платежа'
        throw new Error(message)
      }
      return response.data.data
    }
  }
}
